import { render, staticRenderFns } from "./consumerCoupon.vue?vue&type=template&id=b1e00734&"
import script from "./consumerCoupon.vue?vue&type=script&lang=js&"
export * from "./consumerCoupon.vue?vue&type=script&lang=js&"
import style0 from "./consumerCoupon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports